import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ensureInternalFlagInUrl } from "./utils/internalFlag";
import DemoHub from "./pages/hub/DemoHub";
import PhilippineAirlines from "./components/philippineAirlines/PhilippineAirlines";
import FlightResultsPage from "./components/philippineAirlines/FlightResultsPage";
import ShoppingCartPage from "./components/philippineAirlines/ShoppingCartPage";
import ScandinavianAirlines from "./components/scandinavianAirlines/ScandinavianAirlines";
import FlightSearchResults from "./pages/scandinavianAirlines/FlightSearchResults";
import TravelerDetailsView from "./pages/scandinavianAirlines/TravelerDetailsView";
import DohopHomepage from "./components/dohop/DohopHomepage";
import DohopSearchResults from "./pages/dohop/DohopSearchResults";
import DohopCheckout from "./pages/dohop/DohopCheckout";
import AeroLanding from "./pages/aero/AeroLanding";
import AeroFlightResults from "./pages/aero/AeroFlightResults";
import AeroCheckout from "./pages/aero/AeroCheckout";
import AeroConnectCallback from "./pages/aero/AeroConnectCallback";
import PaConnectCallback from "./pages/philippineAirlines/PaConnectCallback";
import ClicDemo from "./pages/clic/ClicDemo";
import ConnectButtonStart from "./pages/connectButton/ConnectButtonStart";
import ConnectButtonCallback from "./pages/connectButton/ConnectButtonCallback";
import SpreedlyTokenizer from "./pages/spreedlyTokenizer/SpreedlyTokenizer";

/**
 * Keeps the `?mv_internal=1` demo/QA flag (MOVMO-478) on the URL across SPA
 * navigation so the embedded Express Checkout button reads it at mount. Renders
 * nothing; must live inside the Router for `useLocation`.
 */
function InternalFlagKeeper() {
    const location = useLocation();
    useEffect(() => {
        ensureInternalFlagInUrl();
    }, [location]);
    return null;
}

function App() {
    return (
        <BrowserRouter>
            <InternalFlagKeeper />
            <Routes>
                {/* Demo hub — organises every product demo (MOVMO-590) */}
                <Route path="/" element={<DemoHub />} />

                {/* Philippine Airlines routes */}
                <Route
                    path="/philippine-airlines"
                    element={<PhilippineAirlines />}
                />
                <Route
                    path="/philippine-airlines/results"
                    element={<FlightResultsPage />}
                />
                <Route
                    path="/philippine-airlines/shopping-cart"
                    element={<ShoppingCartPage />}
                />
                {/* Movmo identity connect-link OAuth callback (MOVMO-508) —
                    registered at the EXACT redirect_uri path for
                    pa-demo-airline; see src/config/movmoIdentity.ts. */}
                <Route
                    path="/philippine-airlines/connect/callback"
                    element={<PaConnectCallback />}
                />

                {/* Scandinavian Airlines routes */}
                <Route
                    path="/scandinavian-airlines"
                    element={<ScandinavianAirlines />}
                />
                <Route path="/book/flights" element={<FlightSearchResults />} />
                <Route
                    path="/scandinavian-airlines/travelers"
                    element={<TravelerDetailsView />}
                />

                {/* Dohop routes */}
                <Route path="/dohop" element={<DohopHomepage />} />
                <Route path="/dohop/results" element={<DohopSearchResults />} />
                <Route path="/dohop/checkout" element={<DohopCheckout />} />

                {/* Aero routes */}
                <Route path="/aero" element={<AeroLanding />} />
                <Route path="/aero/flights" element={<AeroFlightResults />} />
                <Route path="/aero/checkout" element={<AeroCheckout />} />
                {/* Movmo identity connect-link OAuth callback (MOVMO-508) —
                    registered at the EXACT redirect_uri path for
                    aero-demo-airline; see src/config/movmoIdentity.ts. */}
                <Route
                    path="/aero/connect/callback"
                    element={<AeroConnectCallback />}
                />

                {/* Clic (KIU) screenshot demo — MOVMO-511 */}
                <Route path="/clic" element={<ClicDemo />} />

                {/* @movmo/connect-button local test surface */}
                <Route
                    path="/connect-button"
                    element={<ConnectButtonStart />}
                />
                <Route
                    path="/connect-button/callback"
                    element={<ConnectButtonCallback />}
                />

                {/* Spreedly Hosted Fields tokenizer — captures a real
                    payment_method.token in the E2E sandbox so e2e tests can
                    drive a Spreedly-vaulted booking end-to-end. */}
                <Route
                    path="/spreedly-tokenizer"
                    element={<SpreedlyTokenizer />}
                />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
